import React from 'react';
import { BellIcon, UserIcon, GlobeIcon, MenuIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function AdminHeader() {
  const {
    lang,
    setLang
  } = useLanguage();
  return <header className="w-full bg-[#0F172A] text-white h-16 flex items-center justify-between px-6 shadow-md z-50 relative" data-id="element-20" data-mp="fgu0inb2rkid">
      <div className="flex items-center gap-4" data-id="element-21" data-mp="ajkdfeb5rkxp">
        <div className="lg:hidden" data-id="element-22" data-mp="3iy2egw2om07t">
          <MenuIcon className="w-6 h-6 text-slate-300" data-id="element-23" data-mp="3izdkz3nihm2m" />
        </div>
        <div className="font-bold text-lg tracking-tight font-heading" data-id="element-24" data-mp="3exilm4p55irh">
          Brossard
        </div>
      </div>

      <div className="flex items-center gap-6" data-id="element-25" data-mp="3sxt7etblg75s">
        <button onClick={() => setLang(lang === 'fr' ? 'en' : 'fr')} className="flex items-center gap-2 text-slate-300 hover:text-white transition-colors" title={lang === 'fr' ? 'Passer en anglais' : 'Switch to French'} data-id="element-26" data-mp="3suf9bx9yqk45">
          <GlobeIcon className="w-5 h-5" data-id="element-27" data-mp="136odd4ve992m" />
          <span className="text-sm font-medium hidden sm:block" data-id="element-28" data-mp="g9f7netxfkr1">
            {lang === 'fr' ? 'EN' : 'FR'}
          </span>
        </button>

        <button className="relative text-slate-300 hover:text-white transition-colors" data-id="element-29" data-mp="l7gpxxjj3g1g">
          <BellIcon className="w-5 h-5" data-id="element-30" data-mp="q7bgu13b05mi" />
          <span className="absolute -top-1 -right-1 w-2 h-2 bg-[#4F46E5] rounded-full" data-id="element-31" data-mp="q8cumdbpf67x"></span>
        </button>

        <button className="flex items-center gap-3 pl-4 border-l border-slate-700" data-id="element-32" data-mp="v4bm49sbx4ck">
          <div className="w-8 h-8 rounded-full bg-slate-700 flex items-center justify-center text-sm font-bold" data-id="element-33" data-mp="3tq4pbzh8649t">
            JD
          </div>
        </button>
      </div>
    </header>;
}